import Base from '../Base';
import TableFilter from '../components/TableFilter';
export default class DetailPage extends Base {
    init(id, main, locale) {
        console.log(':: Detailpage ::');

        this.sectionTableauFiltre = document.querySelectorAll("#section_table_filtre");
        if(this.sectionTableauFiltre.length > 0){
            this.initTables();
        }

         //Tables
        this.sectionTable = document.querySelectorAll(".compare-table.tableContainer");
        if (this.sectionTable.length > 0) {
            this.initSectionTable();
        }
        window.addEventListener("click", this.onWindowClick);
    }

    initSectionTable() {
        this.infoPopupsOpen = [];
        this.infoPopupsClose = [];

        for (var i = 0; i < this.sectionTable.length; i++) {
            this.infoPopupsOpen[i] = this.sectionTable[i].querySelectorAll(".info-popup__btn");
            this.infoPopupsClose[i] = this.sectionTable[i].querySelectorAll(".info-popup__close");

            for (var j = 0; j < this.infoPopupsOpen[i].length; j++) {
                this.infoPopupsOpen[i][j].addEventListener("click", this.onPopupToggle);
                this.infoPopupsClose[i][j].addEventListener("click", this.onPopupClose);
            }

        }
        
    }

    onPopupToggle(e) {
        const panel = e.currentTarget.nextElementSibling;

        // close any previously open popup
        if (!panel.classList.contains("open")) {
            const previouslyOpen = document.querySelector(".info-popup__popup.open");
            if (previouslyOpen && previouslyOpen !== panel) {
                previouslyOpen.classList.remove("open");

                //use same logic as below to remove front and back classes from already opened popup
                const closestRowGroup = previouslyOpen.closest("[role=rowgroup]");
                const closestCompareCol = previouslyOpen.closest(".compare-col");
                const compareColSibling = closestCompareCol.parentElement.children;
                const rowGroupSibling = closestRowGroup.parentElement.children;

                for (let i = 0; i < rowGroupSibling.length; i++) {
                    rowGroupSibling[i].classList.remove("back");
                    rowGroupSibling[i].classList.remove("front");
                }

                for (let i = 0; i < compareColSibling.length; i++) {
                    compareColSibling[i].classList.remove("back");
                    compareColSibling[i].classList.remove("front");
                }
            }
        }

        const closestRowGroup = e.currentTarget.closest("[role=rowgroup]");
        const closestCompareCol = e.currentTarget.closest(".compare-col");
        const compareColSibling = closestCompareCol.parentElement.children;
        const rowGroupSibling = closestRowGroup.parentElement.children;

       
        for (let i = 0; i < rowGroupSibling.length; i++) {
            rowGroupSibling[i].classList.add("back");
        }

        closestRowGroup.classList.remove("back");
        closestRowGroup.classList.add("front");

        for (let i = 0; i < compareColSibling.length; i++) {
            compareColSibling[i].classList.add("back");
        }

        closestCompareCol.classList.remove("back");
        closestCompareCol.classList.add("front");



        // toggle open state
        panel.classList.add("open");
        if (panel.classList.contains("open")) {
            // set position
            const bounds = e.currentTarget.getBoundingClientRect();
            const panelBounds = panel.getBoundingClientRect();
            const maxTop = window.innerHeight - panelBounds.height - bounds.height - 24;
            const maxLeft = window.innerWidth - panelBounds.width - 64;

            // console.log("popup top", bounds.top, maxTop);
            panel.style.setProperty("--popup-top", Math.min(bounds.top, maxTop) + "px");
            panel.style.setProperty("--popup-left", Math.min(bounds.left, maxLeft) + "px");
        }
        }

    onPopupClose(e) {
        const panel = e.currentTarget.parentElement;
        panel.classList.remove("open");
    }

    onWindowClick(e) {
        if (!e.target.closest(".info-popup")) {
          const popups = document.querySelectorAll(".info-popup__popup.open");
          for (let i = 0; i < popups.length; i++) {
            popups[i].classList.remove("open");
            const closestRowGroup = popups[i].closest("[role=rowgroup]");
            const closestCompareCol = popups[i].closest(".compare-col");
            const compareColSibling = closestCompareCol.parentElement.children;
            const rowGroupSibling = closestRowGroup.parentElement.children;

            for (let i = 0; i < rowGroupSibling.length; i++) {
                rowGroupSibling[i].classList.remove("back");
                rowGroupSibling[i].classList.remove("front");
            }

            for (let i = 0; i < compareColSibling.length; i++) {
                compareColSibling[i].classList.remove("back");
                compareColSibling[i].classList.remove("front");
            }
          }
        }
    }

    initTables(){
        this.tables = [];
        for(var i = 0; i < this.sectionTableauFiltre.length; i++){
            var table = new TableFilter(this.sectionTableauFiltre[i]);
            this.tables.push(table);
        }
    }
}